import COLORS from '../../../utils/constants/colors'

const selectRecentLivestreamDialogStyles = {
  inlinePanel: {
    width: '100%',
    marginTop: 8,
    border: '1px solid #ECECEC',
    borderRadius: 8,
    backgroundColor: '#FAFAFA',
    maxHeight: 220,
    overflowY: 'auto',
  },
  listItemText: {
    fontSize: '0.9rem',
    fontWeight: 500,
  },
  loader: {
    width: 30,
    height: 30,
    margin: 30,
    fill: COLORS.orange,
  },
  emptyText: {
    fontSize: '0.9rem',
    fontWeight: 500,
    padding: '0 16px',
  },
}

export default selectRecentLivestreamDialogStyles
